import { connect } from 'react-redux';

import { changeQuickShopVisibility } from '../actions';
import QuickShopModalTrigger from '../components/QuickShopModalTrigger';

const mapStateToProps = (state, { taxonName }) => ({ taxonName });

const mapDispatchToProps = dispatch => ({
  openQuickShopModal: (variants, showExciseTaxDisclaimer, taxonName) => {
    dispatch(
      changeQuickShopVisibility(
        true,
        variants,
        showExciseTaxDisclaimer,
        taxonName
      )
    );
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuickShopModalTrigger);
